import { render, staticRenderFns } from "./CtcOpportunityModal.vue?vue&type=template&id=77f7be14&scoped=true&"
import script from "./CtcOpportunityModal.vue?vue&type=script&lang=js&"
export * from "./CtcOpportunityModal.vue?vue&type=script&lang=js&"
import style0 from "./CtcOpportunityModal.vue?vue&type=style&index=0&id=77f7be14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f7be14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCardText,VIcon})
